import { Box, Tab, Tabs } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useQuery } from '@apollo/react-hooks';
import React, { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { USER_DETAILS } from '../graphQL/queries';
import ParticipantGrid from '../ParticipantGrid';
import ParticipantDetail from '../ParticipantDetail';
import ServiceGrid from '../ServiceGrid';
import Dashboard from '../Dashboard';
import { Loading } from '../../Loading';
import ErrorDiagnosis from '../ErrorDiagnosis/index';
import NotificationGrid from '../Notification/index';
import Users from '../GlobalUsers';
import Certification from '../Certifications';
import FAQ from '../Faq';
import ErrorDiagnosiss from '../ED';

function TabPanel(props: any) {
  const { children, value, index } = props;

  return (
    <div hidden={value !== index} id={`tabpanel-${index}`}>
      {value === index && (
        <Box p={3} style={{ borderLeft: '0px' }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  tabs: {
    backgroundColor: 'transparent',
    color: theme.palette.background.paper
  },
  indicator: {
    backgroundColor: theme.palette.background.paper
  },
  selected: {
    color: theme.palette.background.paper
  },
  textColorInherit: {
    '&:hover': {
      color: theme.palette.background.paper
    },
    '&:focus': {
      color: theme.palette.background.paper
    },
    fontWeight: 400
  },
  tab: {
    borderBottomStyle: 'none !important' as 'none'
  },
  appHeader: {
    fontSize: '30px',
    color: theme.palette.background.paper,
    fontWeight: 500
  }
}));

const MainPage = () => {
  const classes = useStyles();
  let history = useHistory();
  const match = useRouteMatch();
  const [userRole, setUserRole] = React.useState('');
  const [participantCode, setParticipantCode] = React.useState('');
  const { loading: userLoading, data: userData } = useQuery(USER_DETAILS, {});

  const handleChange = (event: any, newValue: any) => {
    if (newValue === '/participant' && (userRole === 'PARTICIPANT_SUPPORT' || userRole === 'PARTICIPANT_ADMIN')) {
      newValue = '/participant';
    }
    history.push(newValue);
  };

  useEffect(() => {
    sessionStorage.setItem('enableED', 'false');
  }, []);

  useEffect(() => {
    setUserRole(userData?.userProfile?.roles?.[0]);
    setParticipantCode(userData?.userProfile?.participantRoleInfos?.[0]?.participant?.participantCode);
  }, [userData]);

  return (
    <Box overflow="hidden" width="100%">
      {userLoading ? (
        <Loading />
      ) : (
        <>
          <Box px={3.5} py={2} className={classes.appHeader}>
            Network Services
          </Box>
          <Box pl={3.5}>
            <Tabs
              value={match?.url}
              onChange={handleChange}
              data-id="main-tabs"
              classes={{
                indicator: classes.indicator,
                root: classes.tabs
              }}
            >
              <Tab
                label="DASHBOARD"
                value={'/dashboard'}
                className={classes.tab}
                classes={{
                  selected: classes.selected,
                  textColorInherit: classes.textColorInherit
                }}
              />
              <Tab
                label="PARTICIPANTS"
                value={'/participant'}
                className={classes.tab}
                classes={{
                  selected: classes.selected,
                  textColorInherit: classes.textColorInherit
                }}
              />
              {(userRole === 'APP_ADMIN' || userRole === 'APP_SUPPORT') && (
                <Tab
                  label="SERVICES"
                  value="/service"
                  className={classes.tab}
                  classes={{
                    selected: classes.selected,
                    textColorInherit: classes.textColorInherit
                  }}
                />
              )}
              {(userRole === 'APP_ADMIN' || userRole === 'APP_SUPPORT') && (
                <Tab
                  label="ERROR DIAGNOSIS"
                  value="/errorDiagnosis"
                  className={classes.tab}
                  classes={{
                    selected: classes.selected,
                    textColorInherit: classes.textColorInherit
                  }}
                />
              )}
              {(userRole === 'APP_ADMIN' || userRole === 'APP_SUPPORT') && (
                <Tab
                  label="NOTIFICATIONS"
                  value="/notifications"
                  className={classes.tab}
                  classes={{
                    selected: classes.selected,
                    textColorInherit: classes.textColorInherit
                  }}
                />
              )}
              {/* <Tab
          label="REPORTS"
          value="/report"
          className={classes.tab}
          classes={{
            selected: classes.selected,
            textColorInherit: classes.textColorInherit
          }}
        /> */}
              {(userRole === 'APP_ADMIN' || userRole === 'APP_SUPPORT') && (
                <Tab
                  label="USERS"
                  value="/users"
                  className={classes.tab}
                  classes={{
                    selected: classes.selected,
                    textColorInherit: classes.textColorInherit
                  }}
                />
              )}
              {(userRole === 'APP_ADMIN' || userRole === 'APP_SUPPORT') && (
                <Tab
                  label="CERTIFICATION"
                  value="/certification"
                  className={classes.tab}
                  classes={{
                    selected: classes.selected,
                    textColorInherit: classes.textColorInherit
                  }}
                />
              )}
              {/* <Tab
                label="ED"
                value="/ed"
                className={classes.tab}
                classes={{
                  selected: classes.selected,
                  textColorInherit: classes.textColorInherit
                }}
              /> */}
            </Tabs>
          </Box>
          <TabPanel value={match?.url} index="/dashboard">
            <Dashboard userData={userData} />
          </TabPanel>
          <TabPanel value={match?.url} index="/participant">
            <ParticipantGrid />
          </TabPanel>

          {(userRole === 'APP_ADMIN' || userRole === 'APP_SUPPORT') && (
            <TabPanel value={match?.url} index="/service">
              <ServiceGrid />
            </TabPanel>
          )}
          {/* {sessionStorage.getItem('enableED') === 'true' && (userRole === 'APP_ADMIN' || userRole === 'APP_SUPPORT') && (
            <TabPanel value={match?.url} index="/errorDiagnosis">
              <ErrorDiagnosis
                id="ErrorDiagnosisTab"
                isAdminLevel
                history={history}
                search={history?.location?.search}
              />
            </TabPanel>
          )} */}
          {/* {sessionStorage.getItem('enableED') === 'false' && (userRole === 'APP_ADMIN' || userRole === 'APP_SUPPORT') && ( */}
          <TabPanel value={match?.url} index="/errorDiagnosis">
            <ErrorDiagnosiss id="ErrorDiagnosisTab" isAdminLevel history={history} search={history?.location?.search} />
          </TabPanel>
          {/* )} */}
          {(userRole === 'APP_ADMIN' || userRole === 'APP_SUPPORT') && (
            <TabPanel value={match?.url} index="/notifications">
              <NotificationGrid />
            </TabPanel>
          )}
          {(userRole === 'APP_ADMIN' || userRole === 'APP_SUPPORT') && (
            <TabPanel value={match?.url} index="/users">
              <Users />
            </TabPanel>
          )}
          {(userRole === 'APP_ADMIN' || userRole === 'APP_SUPPORT') && (
            <TabPanel value={match?.url} index="/certification">
              <Certification userData={userData} />
            </TabPanel>
          )}
          <TabPanel value={match?.url} index="/audit">
            audit
          </TabPanel>
          <TabPanel value={match?.url} index="/report">
            report
          </TabPanel>
          {/* <TabPanel value={match?.url} index="/errorDiagnosis">
            <ErrorDiagnosiss id="ErrorDiagnosisTab" isAdminLevel history={history} search={history?.location?.search} />
          </TabPanel> */}

          {/* </Box> */}
        </>
      )}
    </Box>
  );
};

export default MainPage;
